import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Select from 'react-select';
import {
   Panel,
   Button,
   Row,
   Col
  } from 'react-bootstrap';
import * as Actions from 'actions';
import {
  cancelJobNimbusIntegration,
  fetchJobNimbusAccountSettings,
  saveEditedUser
 } from 'api';
import {
  JNInitWizardContainer,
  ConfirmationPrompt,
  JNCancellationOpts,
  LoadingSpinner
} from 'components';

let _mounted = false;

class JobNimbusContainer extends React.Component {
  constructor(props) {
    super(props);

    const { user } = this.props.users;
    this.state = {
      cancelling: false,
      initializing: false,
      show_confirm_quit_init_modal: false,
      show_cancellation_opts_modal: false,
      show_confirm_cancal_integration_modal: false,
      fetching_settings: false,
      updating_settings: false,
      contact_workflows: [],
      updated_type_default: null,
      updated_status_default: null,
      sending_user_update: false
    }

    this.handleClickQuitInit = this.handleClickQuitInit.bind(this);
    this.handleClickCancelIntegration = this.handleClickCancelIntegration.bind(this);
    this.handleConfirmCancelIntegration = this.handleConfirmCancelIntegration.bind(this);
    this.initializeUpdateSettings = this.initializeUpdateSettings.bind(this);
    this.handleTypeDefaultChange = this.handleTypeDefaultChange.bind(this);
    this.handleUpdateSettings = this.handleUpdateSettings.bind(this);
  }

  handleClickQuitInit() {
    this.setState({ show_confirm_quit_init_modal: true });
  }
  handleClickCancelIntegration() {
    this.setState({ show_cancellation_opts_modal: true });
  }
  handleConfirmCancelIntegration(reset_preference) {
    const { user } = this.props.users;

    this.setState({ cancelling: true, show_cancellation_opts_modal: false });
    cancelJobNimbusIntegration({ reset_preference })
    .then(() => {
      this.props.toggleJobNimbusAuthError(false);
      this.props.updateUser({ settings: { ...user.settings, jobnimbus: null } });
      this.props.notify(
        { title: 'Success!', message: 'Job Nimbus integration cancelled successfully' },
        { type: 'success' }
      );
      if(_mounted) {
        this.setState({ cancelling: false });
      }
    })
    .catch(e => {
      this.props.notify({ message: e.message || e });
      if(_mounted) {
        this.setState({ cancelling: false });
      }
    });
  }
  initializeUpdateSettings() {
    const { user } = this.props.users;
    this.setState({ fetching_settings: true });
    fetchJobNimbusAccountSettings(user.settings.jobnimbus.api_key)
    .then(res => {
      if(res.statusCode != 200) {
        if(_mounted) {
          this.setState({ fetching_settings: false });
        }

        if(res.statusCode == 401) {
          this.props.toggleJobNimbusAuthError(true);
          if(_mounted) {
            this.setState({ fetching_settings: false });
          }
          throw new Error(
            `Unauthorized request. Most likely from an invalid Job Nimbus API key or expired Job Nimbus account.
            Please log in to your Job Nimbus account to resolve the issue`
          );
        }
        else {
          throw new Error('Error from Job Nimbus server. Contact a Hail Trace admin if the problem persists');
        }
      }

      const { workflows } = res.body;
      if(_mounted) {
        const { type_default, status_default } = this.props.users.user.settings.jobnimbus;
        const filtered_workflows = workflows.filter(wf => wf.object_type == 'contact');
        let type_default_select_val = null;
        let status_default_select_val = null;
        if(type_default && status_default) {
          const current_type_default = filtered_workflows.find(wf => wf.name == type_default);
          const current_status_default = current_type_default.status.find(s => s.name == status_default);
          type_default_select_val = { value: current_type_default.id, label: current_type_default.name, clearableValue: false };
          status_default_select_val = { value: current_status_default.id, label: current_status_default.name, clearableValue: false };
        }
        this.setState({
          contact_workflows: filtered_workflows,
          fetching_settings: false,
          updating_settings: true,
          updated_type_default: type_default_select_val,
          updated_status_default: status_default_select_val
        });
      }
    })
    .catch(ex => {
      this.props.notify({ message: ex.message || ex });
      if(_mounted) {
        this.setState({ fetching_settings: false });
      }
    })
  }
  handleTypeDefaultChange(select_val) {
    if(
      this.state.updated_type_default &&
      this.state.updated_type_default.value != select_val.value
    ) {
      this.setState({ updated_type_default: select_val, updated_status_default: null });
    }
    else if(!this.state.updated_type_default) {
      this.setState({ updated_type_default: select_val });
    }
  }
  handleUpdateSettings() {
    const { updated_type_default, updated_status_default } = this.state;
    if(updated_type_default != null && updated_status_default != null) {
      const { user } = this.props.users;
      this.setState({ sending_user_update: true });
      saveEditedUser({
        _id: user._id,
        settings: {
          ...user.settings,
          jobnimbus: {
            ...user.settings.jobnimbus,
            type_default: this.state.updated_type_default.label,
            status_default: this.state.updated_status_default.label
          }
        }
      })
      .then(updated_user => {
        this.props.updateUser(updated_user);
        this.props.notify(
          { message: 'Settings updated sucessfully', title: 'Success!' },
          { type: 'success' }
        );
        if(_mounted) {
          this.setState({ sending_user_update: false, updating_settings: false });
        }
      })
      .catch(ex => {
        this.props.notify({ message: ex.message || ex });
        if(_mounted) {
          this.setState({ sending_user_update: false, updating_settings: false });
        }
      });
    }
  }
  componentDidMount() {
    _mounted = true;
  }
  componentWillUnmount() {
    _mounted = false;
  }

  render() {
    const { users: { user }, jobnimbus_auth_error } = this.props;

    const _self = this;
    const type_default_opts =
      this.state.updating_settings ?
      this.state.contact_workflows.map(wf => ({ value: wf.id, label: wf.name, clearableValue: false })) :
      [];
    const { updated_type_default } = this.state;
    const current_type_default = this.state.contact_workflows.find(t => updated_type_default && t.id == updated_type_default.value);
    const status_default_opts =
      current_type_default ?
      current_type_default.status.map(s => ({ value: s.id, label: s.name, clearableValue: false })) :
      [];

    return (
      <div className='jobnimbus-container'>
        <Panel
          bsStyle='primary'
          header='Job Nimbus'
          >
          {(() => {
            if(user.settings && user.settings.jobnimbus) {
              if(this.state.cancelling) {
                return (
                  <div>
                    <p>Cancellling integration ...</p>
                    <LoadingSpinner />
                  </div>
                )
              }
              else if(this.state.fetching_settings) {
                return (
                  <div>
                    <p>Fetching Job Nimbus settings ...</p>
                    <LoadingSpinner />
                  </div>
                );
              }
              else if(this.state.sending_user_update) {
                return (
                  <div>
                    <p>Updating your Job Nimbus settings ...</p>
                    <LoadingSpinner />
                  </div>
                );
              }
              else if(this.state.updating_settings) {
                return (
                  <div>
                    <Row>
                      <Col xs={12} md={6}>
                        <p>Contact Type</p>
                        <Select
                          clearable={false}
                          options={type_default_opts}
                          onChange={this.handleTypeDefaultChange}
                          value={this.state.updated_type_default}
                          placeholder='Choose a Contact Type'
                        />
                      </Col>
                      <Col xs={12} md={6}>
                        <p>Status</p>
                        <Select
                          clearable={false}
                          disabled={current_type_default == null}
                          options={status_default_opts}
                          onChange={val => this.setState({ updated_status_default: val })}
                          value={this.state.updated_status_default}
                          placeholder={current_type_default ? 'Choose a Status Name' : 'Must choose a Contact Type before choosing a status'}
                        />
                      </Col>
                    </Row>
                    <Row className='mt-md'>
                      <Col xs={6} md={3} mdOffset={6}>
                        <Button
                          block
                          bsSize='small'
                          bsStyle='default'
                          onClick={() => this.setState({ updating_settings: false })}
                          >Cancel
                        </Button>
                      </Col>
                      <Col xs={6} md={3}>
                        <Button
                          block
                          bsSize='small'
                          bsStyle='success'
                          disabled={this.state.updated_type_default == null || this.state.updated_status_default == null}
                          onClick={this.handleUpdateSettings}
                          >Submit
                        </Button>
                      </Col>
                    </Row>
                  </div>
                );
              }
              else {
                return (
                  <div>
                    <p>Your Hail Trace account is currently integrated with your Job Nimbus account.</p>
                    <ul>
                      {jobnimbus_auth_error == false ? (
                        <li>
                          <strong
                            onClick={this.initializeUpdateSettings}
                            className='jobnimbus-integration-update-link'
                            >
                            Click Here{' '}
                          </strong>
                          to update your default
                          Contact Type and/or Status (this will only affect clients/contacts created after the udpate).
                        </li>
                      ) : null}
                      <li>
                        <strong
                          onClick={() => this.setState({ show_cancellation_opts_modal: true })}
                          className='jobnimbus-integration-cancel-link'
                          >
                          Click Here{' '}
                        </strong>
                        to cancel your integration with Job Nimbus.
                      </li>
                    </ul>
                  </div>
                )
              }
            }
            else {
              return (
                <p>
                  <strong
                    onClick={() => {this.setState({ initializing: true })}}
                    className='jobnimbus-integration-init-link'
                    >Click Here </strong>
                  to integrate your Hail Trace account with your current Job Nimbus account
                </p>
              );
            }
          })()}
        </Panel>

        <JNInitWizardContainer
          show={this.state.initializing}
          onHide={this.handleClickQuitInit}
          toggleInitializing={() => this.setState({ initializing: false })}
        />

        <ConfirmationPrompt
          show_condition={this.state.show_confirm_quit_init_modal}
          handleCancelPrompt={() => {this.setState({ show_confirm_quit_init_modal: false })}}
          handleConfirmPrompt={() => {this.setState({ show_confirm_quit_init_modal: false, initializing: false })}}
          body='Are you sure you want to quit? All of your current integration settings will be lost.'
          confirm_button_text='Confirm'
          cancel_button_text='Cancel'
          type='danger'
        />

        <JNCancellationOpts
          show={this.state.show_cancellation_opts_modal}
          onHide={() => {this.setState({ show_cancellation_opts_modal: false })}}
          handleClickKeepCurrentData={() => this.handleConfirmCancelIntegration(false)}
          handleClickResetData={() => this.handleConfirmCancelIntegration(true)}
        />

        <ConfirmationPrompt
          show_condition={this.state.show_confirm_cancal_integration_modal}
          handleCancelPrompt={() => {this.setState({ show_cancellation_opts_modal: false })}}
          handleConfirmPrompt={this.handleClickCancelIntegration}
          body='Are you sure you want to cancel your Job Nimbus Integration?'
          confirm_button_text='Confirm'
          cancel_button_text='Cancel'
          type='danger'
        />
      </div>
    );
  }
}

const mapStateToProps = ({ users, integrations: { jobnimbus_auth_error } }) => ({ users, jobnimbus_auth_error });

export default connect(mapStateToProps, Actions)(JobNimbusContainer);



// WEBPACK FOOTER //
// ./src/browser/components/settings/integrations/jobnimbus/jobnimbus-container.js